import { useWindowSize } from '../../../shared/hooks';

// RDS Button takes `size` as a JS prop, not a CSS class, so it can't respond to a Tailwind
// breakpoint on its own. Mirrors ReferralForm's own pre-TRUSTED-96145 pattern
// (useWindowSize()?.width > 599 ? 'large' : 'medium'), since removed there but wanted here.
function useMatcherButtonSize(): 'medium' | 'large' {
  const { width } = useWindowSize();
  return width > 599 ? 'large' : 'medium';
}

export { useMatcherButtonSize };
